import { notificationQueryKeys as e } from "./notificationQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { useIsAuthenticated as n } from "@maat/store-auth";
import { notificationsApi as r } from "@maat/api-notifications";
//#region src/notifications/useNotificationsUnreadCountQuery.ts
var i = () => {
	let i = n();
	return t({
		queryKey: e.unreadCount(),
		queryFn: () => r.getUnreadCount(),
		enabled: i,
		refetchInterval: 6e4
	});
};
//#endregion
export { i as useNotificationsUnreadCountQuery };
